import { GetterTree } from 'vuex'
import { RootState } from '@/store/types'
import { SynergridConnectionState } from './types';

export const getters: GetterTree<SynergridConnectionState, RootState> = {}
